export default __webpack_public_path__ + "static/media/caleb-self-mastery.82687c50.svg";